import { useEffect, useMemo, useState } from 'react';
import { useCall } from './CallContext';

function formatDuration(ms) {
  if (!Number.isFinite(ms) || ms < 0) ms = 0;
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  const pad = (n) => String(n).padStart(2, '0');
  if (h > 0) return `${h}:${pad(m)}:${pad(s)}`;
  return `${pad(m)}:${pad(s)}`;
}

export function useCallTimer() {
  const { callStartAt, activeRoomId, state } = useCall() || {};
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    // Run only when in a call
    if (!activeRoomId || !callStartAt || !state?.joined) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [activeRoomId, callStartAt, state?.joined]);

  const elapsedMs = useMemo(() => {
    if (!activeRoomId || !callStartAt || !state?.joined) return 0;
    return Math.max(0, now - callStartAt);
  }, [now, callStartAt, activeRoomId, state?.joined]);

  return {
    elapsedMs,
    label: formatDuration(elapsedMs),
    active: !!(activeRoomId && callStartAt && state?.joined)
  };
}

export function formatCallDuration(ms) { return formatDuration(ms); }
